import { Component, Input, OnInit } from '@angular/core';
import { FormFieldConfig } from '../../../dropdown/form_field_config';

@Component({
  selector: 'app-resources-column',
  templateUrl: './resources-column.component.html',
  styleUrls: ['./resources-column.component.css']
})
export class ResourcesColumnComponent implements OnInit {
  @Input() config: any;

  constructor() { }

  ngOnInit(): void {
  }

}
